module.exports = __webpack_public_path__ + "img/success-icon.46dbef96.png";